import React, { useEffect } from 'react';

import { trackEvent } from '@utils/analytics';
import { useHistoryOrderDetailsStore } from '@stores/historyOrder';
import { useNavigation } from '@hooks';
import { useOrderDetailsStore } from '@stores/order';

import { OrderView } from './OrderView';

type OrderContainerProps = {
  orderUUID: string;
  isHistoryOrderFlag: boolean;
};

export const OrderContainer: React.FC<OrderContainerProps> = ({
  orderUUID,
  isHistoryOrderFlag,
}) => {
  const navigation = useNavigation();
  const { order, loading, subscribe } = useOrderDetailsStore();
  const {
    order: historyOrder,
    loading: historyLoading,
    fetch: fetchHistoryOrderDetails,
  } = useHistoryOrderDetailsStore();

  useEffect(() => {
    try {
      // check if order is history order or not
      if (isHistoryOrderFlag && historyOrder?.orderMessage.uuid !== orderUUID) {
        fetchHistoryOrderDetails(orderUUID);
      } else if (order?.orderMessage.uuid !== orderUUID) {
        // only resubscribe and show loading if order id is different than the currently loaded order
        subscribe(orderUUID);
      }
      
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown subscription error';
      // This catches logic errors in your hooks/calls
      trackEvent('order_subscription_error', {
        order_id: orderUUID,
        error: errorMessage
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fetchHistoryOrderDetails,
    isHistoryOrderFlag,
    order?.orderMessage.uuid,
    orderUUID,
    subscribe,
  ]);

  return (
    <OrderView
      order={isHistoryOrderFlag ? historyOrder : order}
      loading={isHistoryOrderFlag ? historyLoading : loading}
      onBackPress={() => navigation.goBack()}
    />
  );
};
